export default __webpack_public_path__ + "media/images/banners/months/bnr_2-2d2370f4ad8c43de80cea9b0d27ec2bb.jpg";